import api from 'Application/api/api';

const getTranches = (signal, configuration, filters = {}, searchQuery) => {
	const { sortBy = 'dateModified', sortDirection = '' } = configuration;

	const params = {
		...filters,
		...configuration,
		query: searchQuery,
	};

	if (sortBy && sortDirection) {
		params.sort = `${sortBy},${sortDirection}`;
	}

	return api.get('/tranches/get-pageable', {
		params,
		signal,
		timeout: 100000,
	});
};

export default getTranches;
